<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">CMS系统/</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>统计查询</el-breadcrumb-item>
            <el-breadcrumb-item>资讯统计</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 20px">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedUser" @change="handleChecked">
                <el-checkbox style="width: 200px;margin-bottom: 10px" v-for="(item,index) in users" :label="item.tel"
                             :key="item.id+index"></el-checkbox>
            </el-checkbox-group>
        </div>

        <div style="margin-top: 20px">
            <el-select v-model="params.type" placeholder="请选择时间类型">
                <el-option key="DAY" label="天" value="DAY"></el-option>
                <el-option key="MONTH" label="月" value="MONTH"></el-option>
                <el-option key="YEAR" label="年" value="YEAR"></el-option>
            </el-select>

            <el-date-picker v-model="dateArr" type="datetimerange" value-format="timestamp"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right">
            </el-date-picker>

            <el-button style="margin-left: 30px" type="primary" @click="getStatisticsData">
                统计
            </el-button>
        </div>

        <el-table :data="dataList" :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table class="demo-table-expand" :data="props.row.detail" stripe style="width: 100%">
                        <el-table-column prop="time" label="时间"></el-table-column>
                        <el-table-column prop="articleNum" label="文章数量"></el-table-column>
                        <el-table-column prop="newsNum" label="资讯数量"></el-table-column>
                        <el-table-column prop="totalNum" label="总数"></el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="userAccount" label="用户账号" width="180"></el-table-column>
            <el-table-column label="文章数量">
                <template slot-scope="scope">
                    <span>{{scope.row.detail | formatArticleNum}}</span>
                </template>
            </el-table-column>
            <el-table-column label="快讯数量">
                <template slot-scope="scope">
                    <span>{{scope.row.detail | formatNewsNum}}</span>
                </template>
            </el-table-column>
            <el-table-column label="总数">
                <template slot-scope="scope">
                    <span>{{scope.row.detail | formatTotalNum}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';


    export default {
        name: 'statisticsNews',
        components: {},
        data() {
            return {
                isIndeterminate: true,
                checkAll: false,
                checkedUser: [],
                users: [],
                params: {userIds: '', type: 'DAY', startTime: null, endTime: null},
                dateArr: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dataList: [],
            };
        },
        filters: {
            formatArticleNum(detail) {
                let num = 0;
                detail.forEach(x => {
                    num += x.articleNum;
                });
                return num;
            },
            formatNewsNum(detail) {
                let num = 0;
                detail.forEach(x => {
                    num += x.newsNum;
                });
                return num;
            },
            formatTotalNum(detail) {
                let num = 0;
                detail.forEach(x => {
                    num += x.totalNum;
                });
                return num;
            }
        },
        methods: {
            handleCheckAll(val) {
                this.checkedUser = val ? this.users.map(item => item.tel) : [];
                this.isIndeterminate = false;
            },
            handleChecked(val) {
                let len = val.length;
                this.checkAll = len === this.users.length;
                this.isIndeterminate = len > 0 && len < this.users.length;
            },
            getUserList() {
                api.getUserInfoList().then(({data}) => {
                    this.users = data;
                });
            },
            getStatisticsData() {
                if (this.dateArr != null) {
                    this.params.startTime = this.dateArr[0];
                    this.params.endTime = this.dateArr[1];
                } else {
                    this.params.startTime = null;
                    this.params.endTime = null;
                }
                this.params.userIds = this.checkedUser.join(",");
                if (this.params.userIds == null || this.params.userIds.trim() == '') {
                    this.$message.error('请选择用户！');
                    return;
                }
                if (this.params.startTime == null || this.params.startTime == '') {
                    this.$message.error('请选择开始时间！');
                    return;
                }
                if (this.params.endTime == null || this.params.endTime == '') {
                    this.$message.error('请选择结束时间！');
                    return;
                }
                api.getStatisticsData(this.params).then(({data}) => {
                    this.dataList = data;
                });
            },
        },
        created() {
            this.getUserList();
        }
    };
</script>

<style lang="less" scoped>
    .el-checkbox + .el-checkbox {
        margin-left: 0px;
    }
</style>